import { api } from './api';

export interface Role {
  id: string;
  name: string;
  description: string | null;
  isSystem: boolean;
  displayOrder: number;
  userCount: number;
  permissions: string[];
  createdAt: string;
}

export interface Permission {
  id: string;
  code: string;
  name: string;
  description: string | null;
  module: string;
  displayOrder: number;
}

export interface PermissionGroup {
  module: string;
  permissions: Permission[];
}

export interface RoleListResponse {
  items: Role[];
  totalCount: number;
}

export interface CreateRoleRequest {
  name: string;
  description?: string;
  permissionIds: string[];
}

export interface UpdateRoleRequest {
  name: string;
  description?: string;
  permissionIds: string[];
}

export const roleService = {
  async getRoles(page = 1, pageSize = 20): Promise<RoleListResponse> {
    const response = await api.get('/api/roles', {
      params: { page, pageSize }
    });
    return response.data;
  },

  async getRole(id: string): Promise<Role> {
    const response = await api.get(`/api/roles/${id}`);
    return response.data;
  },

  async createRole(data: CreateRoleRequest): Promise<Role> {
    const response = await api.post('/api/roles', data);
    return response.data;
  },

  async updateRole(id: string, data: UpdateRoleRequest): Promise<Role> {
    const response = await api.put(`/api/roles/${id}`, data);
    return response.data;
  },

  async deleteRole(id: string): Promise<void> {
    await api.delete(`/api/roles/${id}`);
  },

  async getPermissions(): Promise<PermissionGroup[]> {
    const response = await api.get('/api/roles/permissions');
    return response.data;
  },

  async getUserRoles(userId: string): Promise<Role[]> {
    const response = await api.get(`/api/roles/user/${userId}`);
    return response.data;
  },

  async assignRolesToUser(userId: string, roleIds: string[]): Promise<void> {
    await api.post(`/api/roles/user/${userId}`, { roleIds });
  }
};
